class ZRegexX {

  /**
   * 
   * @param {String} target 
   * @param {RegExp} regex 
   */
  static FindAllMatches(target, regex){
    let arr = [];
    let res;
    while((res = regex.exec(target)) !== null){
      arr.push(...res);
    };
    return arr;
  }

  static Escape(str){
    str = str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    return str;
  }

  static EscapeHeader(str){
    str = str.replace(/^#/, "\\#");
    return str;
  }

  static ExtractImageSrcFromHTML(html){
    let regex = /<img.*?src=["|'](.*?)["|']/g;
      let arr = regex.exec(html);
      let src = arr?.[1];
      return src;
  }

}

export default ZRegexX;